module.exports = __webpack_public_path__ + "static/media/ri-check-double-line-disabled.6e6907ff.svg";